import { Component } from '@angular/core';

@Component({
  selector: 'blank',
  templateUrl: 'blankLayout.template.html'
})
export class BlankLayoutComponent {

  ngAfterViewInit() {
    const x = document.getElementsByTagName('BODY')[0];
    x.classList.add('mini-navbar');
  }

  ngOnDestroy() {
    const x = document.getElementsByTagName('BODY')[0];
    x.classList.remove('gray-bg');
  }
}
